(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-image-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mm-image-carousel')) {
    customElements.define('mm-image-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.track = this.querySelector('.mmic__track');
        this.slides = Array.from(this.querySelectorAll('.mmic__slide'));
        this.controls = this.querySelector('.mmic__controls');
        this.buttons = Array.from(this.querySelectorAll('.mmic__arrow'));
        this.status = this.querySelector('.mmic__status');
        if (!this.track || !this.controls) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.buttons.forEach(button => button.addEventListener('click', () => this.move(Number(button.dataset.direction)), { signal }));
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        }, { passive: true, signal });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          const rtl = this.isRTL();
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.goTo(event.key === 'Home' ? 0 : this.maximum());
          }
        }, { signal });
        this.addEventListener('shopify:block:select', event => {
          const slide = this.slides.find(item => item.dataset.blockId === event.detail.blockId);
          if (slide) this.goTo(this.slides.indexOf(slide) * this.step(), true);
        }, { signal });
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
        this.update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
      isRTL() { return getComputedStyle(this.track).direction === 'rtl'; }
      maximum() { return Math.max(0, this.track.scrollWidth - this.track.clientWidth); }
      position() { return Math.min(this.maximum(), Math.max(0, Math.abs(this.track.scrollLeft))); }
      step() {
        return (this.slides[0]?.getBoundingClientRect().width || 0) + (parseFloat(getComputedStyle(this.track).columnGap) || 0);
      }
      goTo(position, instant = false) {
        const target = Math.min(this.maximum(), Math.max(0, position));
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: this.isRTL() ? -target : target, behavior: instant || reducedMotion ? 'instant' : 'smooth' });
      }
      move(direction) {
        const maximum = this.maximum();
        const position = this.position();
        const step = this.step();
        if (maximum <= 1 || step <= 0) return;
        const index = direction > 0 ? Math.floor((position + 2) / step) + 1 : Math.ceil((position - 2) / step) - 1;
        this.goTo(index * step);
      }
      update() {
        const maximum = this.maximum();
        const position = this.position();
        this.controls.hidden = maximum <= 1;
        this.buttons[0].disabled = maximum <= 1 || position <= 2;
        this.buttons[1].disabled = maximum <= 1 || position >= maximum - 2;
        const step = this.step();
        const index = Math.min(this.slides.length - 1, Math.max(0, Math.floor((position + 2) / (step || 1))));
        const label = this.slides[index]?.dataset.slideLabel || '';
        if (this.status.textContent !== label) this.status.textContent = label;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
